import * as React from "react";
import { useEffect } from "react";

interface ConfirmLeavePageProps {
    showModal: boolean;
    message?: string;
}

const message = "You have unsaved changes. Are you sure you want to leave?";

const handleBeforeUnload = (event: BeforeUnloadEvent) => {
    event.preventDefault();
    event.returnValue = message;
    return message;
};

const handlePopState = (event: PopStateEvent) => {
    // User cancelled, prevent navigation by pushing the current state
    event.preventDefault();
    window.history.pushState(null, "", window.location.href);

    if (window.confirm(message)) {
        cleanup();
        return;
    }
};

const cleanup = () => {
    window.removeEventListener("beforeunload", handleBeforeUnload);
    window.removeEventListener("popstate", handlePopState);
};

export const ConfirmLeavePageModal: React.FC<ConfirmLeavePageProps> = () => {
    useEffect(() => {
        window.addEventListener("beforeunload", handleBeforeUnload);
        window.addEventListener("popstate", handlePopState);
        return () => {
            cleanup();
        };
    }, []);

    return <></>;
};